<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<template>
	<div class="row">
		<div class="col pr-1">
			<div class="pr-3">
				<div v-if="isSaving"
					 element-loading-spinner="fontello icon-spin5"
					 v-loading="isSaving"/>
			</div>
			<div v-if="isShowingSaved"><i class="fontello icon-ok-circled2 text-success"/></div>
		</div>
		<div class="col pl-0">
			<transition-group name="el-fade-in">
				<div v-if="isSaving" >Saving...</div>
				<div v-if="isShowingSaved">Saved</div>
			</transition-group>
		</div>
	</div>

</template>

<script>
import {delay} from "@/utils/helpers";

export default {
	name: "SavingIndicator",
	props: {
		visible: Boolean
	},
	watch: {
		visible: {
			immediate: true,
			handler(newVal, oldVal) {
				console.log("visible: newVal = ", newVal, ", oldVal = ", oldVal)
				if (newVal) {
					this.show()
				} else {
					this.hide()
				}
			},
		},
	},

	data: () => ({
		isSaving: false,
		isShowingSaved: false,
	}),
	methods: {
		show() {
			this.isSaving = true
			this.isShowingSaved = false;
		},
		async hide() {
			if (this.isSaving) {
				this.isSaving = false;
				return await this.showSaved()
			}
		},
		async hideSuccess() {
			return await this.hide()
		},
		async hideFailed() {
			await this.hideNoMessage()
		},

		hideNoMessage() {
			this.isShowingSaved = false;
			this.isSaving = false;
		},
		async showSaved() {
			this.isShowingSaved = true;
			await delay(2000)
			this.isShowingSaved = false;
		}
	}
}
</script>

<style>

</style>
